'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { useUser } from '@/app_lib/providers/UserProvider';
import { OutbrainLoadingState } from '@/app_lib/services/Outbrain/config';

export const OutbrainScript = () => {
  const { personalizedAds } = useUser();
  const { renderOutbrainScript, setOutbrainScriptLoadedState, setRenderOutbrainScript } = useAdContext();
  const [scriptKey, setScriptKey] = useState(0);

  // Outbrain script re-executes when personalizedAds changes
  useEffect(() => {
    if (personalizedAds === null) {
      return;
    }
    const previousScripts = document.querySelectorAll('script[src*="widgets.outbrain.com"]');
    previousScripts.forEach((script) => script.remove());

    const previousLinks = document.querySelectorAll('link[href*="widgets.outbrain.com"]');
    previousLinks.forEach((link) => link.remove());

    setScriptKey((prev) => prev + 1);

    setOutbrainScriptLoadedState(OutbrainLoadingState.Pending);
    setRenderOutbrainScript(false);
  }, [personalizedAds, setOutbrainScriptLoadedState, setRenderOutbrainScript]);

  return (
    <>
      {renderOutbrainScript && personalizedAds !== null && (
        <Script
          key={scriptKey}
          onError={() => {
            setOutbrainScriptLoadedState(OutbrainLoadingState.Failed);
          }}
          onLoad={() => {
            setOutbrainScriptLoadedState(OutbrainLoadingState.Loaded);
          }}
          src={`https://widgets.outbrain.com/outbrain.js?v=${scriptKey}`}
          strategy='afterInteractive'
        />
      )}
    </>
  );
};
